// extracted by mini-css-extract-plugin
export default {"icon":"_2OirA","more":"_1ouGa","actions":"ShUN5"};